// extracted by mini-css-extract-plugin
module.exports = {"inputPhoneNumber":"_3wrb2tmh_87jNHst-OHFKF","itemChip":"_2GY2nM2aqv1F47p_NjRXJg"};